import React, { useState } from 'react';
import { Header } from '../components/layout';
import { CategoryFilters } from '../components/products';
import { ProductGrid } from '../components/ui';
import { UserOrdersSummary } from '../components/userOrders';
import { UserOrdersModal } from '../components/modals';
import { useHomeData, useUserOrders } from '../hooks';
import { useAuth } from '../context/AuthContext';

const Home: React.FC = () => {
  const [isOrdersModalOpen, setOrdersModalOpen] = useState(false);

  const {
    // Categories
    mainCategories,
    subCategories,
    selectedMainCategory,
    selectedSubCategory,

    // Products
    products,
    loading,
    error,

    // UI State
    showSubFilter,

    // Actions
    setSelectedMainCategory,
    setSelectedSubCategory,
  } = useHomeData();

  const { isAuthenticated } = useAuth();
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || 'null');
  const {
    orders,
    ordersSummary,
    stats,
    loading: ordersLoading,
    error: ordersError,
    fetchUserOrders,
  } = useUserOrders(userInfo?.id || null);

  // Aktif siparişlerin olup olmadığını kontrol et (bekliyor, hazırlanıyor, yolda)
  const hasActiveOrders =
    stats &&
    ((stats.pending_orders || 0) > 0 ||
      (stats.preparing_orders || 0) > 0 ||
      (stats.on_the_way_orders || 0) > 0);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-white to-yellow-50 relative">
      <Header />

      {/* Siparişlerim Bölümü - Sağ üst köşede sabit */}
      {isAuthenticated && userInfo && hasActiveOrders && (
        <div className="fixed top-24 right-6 z-30 w-56 hidden lg:block">
          <UserOrdersSummary
            ordersSummary={ordersSummary}
            stats={stats}
            loading={ordersLoading}
            onViewAllOrders={() => setOrdersModalOpen(true)}
          />
        </div>
      )}

      {/* Mobil için siparişlerim bölümü */}
      {isAuthenticated && userInfo && hasActiveOrders && (
        <div className="lg:hidden px-4 pt-4">
          <UserOrdersSummary
            ordersSummary={ordersSummary}
            stats={stats}
            loading={ordersLoading}
            onViewAllOrders={() => setOrdersModalOpen(true)}
          />
        </div>
      )}

      <main className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 py-10">
        <CategoryFilters
          mainCategories={mainCategories}
          subCategories={subCategories}
          selectedMainCategory={selectedMainCategory}
          selectedSubCategory={selectedSubCategory}
          showSubFilter={showSubFilter}
          onMainCategorySelect={setSelectedMainCategory}
          onSubCategorySelect={setSelectedSubCategory}
        />
        <ProductGrid products={products} loading={loading} error={error} />
      </main>

      {/* Siparişlerim Modal'ı */}
      <UserOrdersModal
        isOpen={isOrdersModalOpen}
        onClose={() => setOrdersModalOpen(false)}
        orders={orders}
        loading={ordersLoading}
        error={ordersError}
        onLoadOrders={fetchUserOrders}
      />
    </div>
  );
};

export default Home;
